import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_trendy-closet-luxury/artifacts/gjf2ticw_Logo%20-%20Trendy%20Closet.png';

/**
 * Trendy Closet circular brand mark.
 * Sizes: 'sm' (32px), 'md' (40px), 'lg' (56px), 'xl' (96px).
 * Uses a subtle gold ring frame that echoes the site aesthetic.
 */
export const Logo = ({ size = 'md', className = '', ring = true, alt = 'Trendy Closet' }) => {
  const dims = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-24 h-24',
  }[size] || 'w-10 h-10';

  return (
    <span
      className={`inline-block relative shrink-0 rounded-full overflow-hidden ${dims} ${
        ring ? 'ring-1 ring-gold/50 ring-offset-2 ring-offset-transparent shadow-sm' : ''
      } ${className}`}
      aria-label={alt}
    >
      <img
        src={LOGO_URL}
        alt={alt}
        loading="eager"
        decoding="async"
        className="w-full h-full object-cover"
        draggable={false}
      />
    </span>
  );
};

export default Logo;
